<template >
<div class="container px-5 py-5" v-if="lesson ">
   

      <div class="card mb-4"  >
        <div class="card-header py-3">
          <div class="row">
            <div class="col col-expand">
              <h3 class="m-0 font-weight-bold text-primary" >{{lesson.name}}</h3>
            </div>
            <div class="col col-auto">
              <!-- <button class="btn btn-sm btn-default" @click="_setFinal(0)">Дундаж дүнг эцсийн дүн болгох</button> -->
              <!-- <button class="btn btn-sm btn-default"  @click="_setFinal(1)">Нийлбэр дүнг эцсийн дүн болгох</button> -->
              <button @click="addScore" class="btn btn-danger btn-sm">Нэмэх</button>
            </div>

          </div>
        </div>
        <div class="card-body" >
          <div>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th style="width:1%" class="text-primary">N</th>
                  <th class="text-primary">Нэр</th>
                  
                  <th class="text-primary" v-for="topic in topics">
                     {{topic.name}} /{{topic.totalScore}}/

                  </th>
                  <th class="text-primary">
                    Дундаж
                    
                  </th>
                  <th class="text-primary">Нийлбэр</th>
                  <!-- <th class="text-primary">Эцсийн дүн</th> -->
                </tr>
              </thead>

              <tbody v-for="(group, gindex) in groups">
                <tr v-for="(student, sindex) in group.students">
                  <td >{{sindex+1}}</td>  
                  <td><span v-if="student.lastname">{{student.lastname[0]}}.</span>{{student.name}}</td>
                  <td v-for="scoredata in student.topics">
                    <!-- {{scoredata}} -->
                    <div v-if="scoredata && scoredata.data" >
                      <div class="">
                        <div class="">
                          <input v-bind:class="[scoredata.data.earnedScore ? 'bg-success' : 'bg-danger']" class="input-sm text-white form-control" placeholder="Оноо оруулаагүй байна!" type="number" v-model.number="scoredata.data.earnedScore" @change="scoreChanged(student,scoredata)"/>
                        </div>
                        
                        <div  class="mt-2" v-if="scoredata.data.earnedScore">
                          <div class="row">
                            <div class="col" v-if="scoredata.data.procent">
                              <div class="progress">
                                <div class="progress-bar bg-info" role="progressbar" v-bind:style="'width: '+scoredata.data.procent+'%'" aria-valuemin="0" aria-valuemax="100">{{scoredata.data.procent}} %</div>
                              </div>
                            </div>
                            <div class="col" v-else>
                              <div class="progress">
                                <div class="progress-bar bg-danger" role="progressbar" v-bind:style="'width: '+0+'%'" aria-valuemin="0" aria-valuemax="100">0 %</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                  </td>
                  <td>
                    {{_getAvg(student.topics)}}
                  </td>
                  <td>
                    {{_getSum(student.topics)}}
                  </td>
                  <!-- <td>

                    <input class="form-control input-sm" type="number" v-model="student.earnedScore" @change="finalScoreChanged(student)"/>
                  </td> -->
          
                </tr>
              </tbody>
   
            </table>
          </div>
        </div>
      </div>



      <hr class="mb-5"/>
      
  <!-- ContentModal -->
  <div class="modal fade" id="scoreModal" tabindex="-1" role="dialog" aria-labelledby="scoreModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" >Нэмэх</h5>
          
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="user">
            <div class="form-group">
              <label>Явцын дүн нэр: </label>
              <input v-model.trim="content.name" class="form-control" placeholder="нэр">
            </div>
            <div class="form-group">
              <label>Явцын дүгнэх дээд оноо: </label>
              <input v-model.number="content.totalScore" type="number" class="form-control" placeholder="Дээд оноо">
            </div>
            <hr>
            
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
          <button @click="saveScore" type="button" class="btn btn-primary btn-user btn-block">Хадгалах</button>
        </div>
      </div>
    </div>
  </div>

   
</div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment,{ max } from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode';
import LessonInfo from '../shared/LessonInfo';
export default {
    name: "ILessonScores",

    data() {
        return {
            lesson: null,
            topic:null,
            content:{name:null, totalScore:null},
            topics:[],
            types:[],
            selectedType:null,
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],
                        
            display:0,
            tagText:null,
            dayStr:null,
            selectedCell:null,
            selectedTopicIndex:null,
            selectedGroupIndex:null,
            schools:[],
            teachers:[],
            school:null,
            teacher:null,
            groups:[]

            
        };
    },
    methods: {
        
      async _getQA(){


          var doc=await fb.db.collection("lessons").doc(this.lessonId).get();
          let lesson=doc.data();
          lesson.id=doc.id;
          this.lesson=lesson;
          this.groups=[];
          var group={name: ''}
       
          group.students=[];
          group.topics=[];
          for(const topic of this.topics){
            let item= Object.assign({}, topic);
            item.attendance=null;
            group.topics.push(item);
          }
          await this.getTopics();
          this.getStudents(group);
          this.groups.push(group);
      },
      async getStudents(group){
        if(this.lesson){
          var querySnapshot=await fb.db.collection("lessons/"+this.lessonId+'/studentList').get();
        for(const stddata of querySnapshot.docs){
          if(stddata.data().studentRef!=null){
            var studentDoc=await stddata.data().studentRef.get();
            if(studentDoc.exists){
              let student=studentDoc.data();
              student.id=studentDoc.id;
              student.ref=studentDoc.ref;
              student.topics=[];

              for(const topic of this.topics){
                var scoreDoc=Object.assign({}, topic);
                let score=Object.assign({}, {topic: scoreDoc, data:{earnedScore:null}, procent:0});
                
                if(student){
                  var y = {topic: scoreDoc};
                  y.data={earnedScore:null};
                  fb.db.collection("lessons").doc(this.lessonId+"/scores/"+topic.id).collection('sstudents').doc(student.id).onSnapshot(sdoc=>{
                    if(sdoc.exists){
                      score.data=sdoc.data();
                    }
                  });
                  
                }

                student.topics.push(score);
              }
              group.students.push(student);
            }

          }
        }
        }
      },
      async resetStudents(){
        if(this.lesson!=null && this.lesson!=undefined){
          for(const group of this.groups){
            if(group && group.students && group.students.length>0){

              for(const object of group.students){
                object.topics=[];
             
                for(const topic of this.topics){

                  var scoreDoc=Object.assign({}, topic);
                  let score=Object.assign({}, {topic: scoreDoc, data:{earnedScore:null}, procent:0});
                  
                  if(object){
                    var y = {topic: scoreDoc};
                    y.data={earnedScore:null};
                    fb.db.collection("lessons").doc(this.lessonId+"/scores/"+topic.id).collection('sstudents').doc(object.id).onSnapshot(sdoc=>{
                      if(sdoc.exists){
                        score.data=sdoc.data();
                        // this.$set(score, 'data', y.data);
                      }
                    });
                    
                  }
                  object.topics.push(score);
                  
                }

              }
        
            }
          }
          
        }
      },


      async getTopics(){
        if(this.lesson!=null && this.lesson!=undefined){
          var topicSnapshot=await fb.db.collection("lessons").doc(this.lesson.id).collection("scores").orderBy("createdAt","asc").get();
          if(topicSnapshot && !topicSnapshot.empty){
            this.topics=[];
            for(const doc of topicSnapshot.docs){
              let object=doc.data();
              object.id = doc.id;
              object.groups=[];
              object.procent=0;
              if(object && object.countScore && object.sumScore){
                object.procent=(80);
              }
              
              this.topics.push(object);
            }
            
          }
          
        }
      },
      _addTopic(gdata, i, j){
        this.dayStr=null;
        this.selectedTopicIndex=i;
        this.selectedGroupIndex=j;
        this.selectedCell=gdata;
        $('#exampleModal').modal('toggle');
      },
      
 
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
    
      setPublished(value, lesson){

      },
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },

        async readSchool(){
          this._getSchools();
            // if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['role']=="admin"){
            //   this._getSchools();
            // }
            // else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null && (this.userProfile['role']=="sts" || this.userProfile['role']=="manager")){
            //    var cusDoc=await this.userProfile['customer'].get();
            //     if(cusDoc.exists && cusDoc.data().schools!=null && cusDoc.data().schools!=undefined && cusDoc.data().schools.length>0){
            //       for(const scRef of cusDoc.data().schools){
            //         scRef.get().then(schoolData=>{
            //           let school = schoolData.data();
            //           school.id=schoolData.id;
            //           school.ref=schoolData.ref;
            //           this.schools.push(school);
                    
            //         });
            //       }
            //     }
            // }
          
            // else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null && this.userProfile['role']=="teacher"){
            //     var cusDoc=await this.userProfile['customer'].get();
            //     if(cusDoc.exists && cusDoc.data().school!=null && cusDoc.data().school!=undefined){

            //         cusDoc.data().school.get().then(schoolData=>{
            //           let school = schoolData.data();
            //           school.id=schoolData.id;
            //           school.ref=schoolData.ref;
            //           this.schools.push(school);
         
            //         });
                  
            //     }
            // }

        },
        schoolChanged(){
          this.teacher=null;
          this.teachers=[];
          fb.db.collection("/teachers").where("school", '==', this.school.ref).get().then(docs=>{
            docs.docs.forEach(value=>{
              let teacher={};
              teacher.id=value.id;
              teacher.code=value.data().code;
              teacher.reference=value.ref;
              teacher.firstName=value.data().name;
              teacher.lastName=value.data().lastname;
              teacher.description=value.data().description;
              this.teachers.push(teacher);
            });
          });
        },
        scoreChanged(student, score){
          if(student && student.id && score && score.topic && score.topic.id && score.data && score.data.earnedScore){
            var maxScore=100;
            if(score.topic && score.topic.totalScore){
              maxScore=score.topic.totalScore;
            }
            if(score.data.earnedScore> maxScore){
              alert("Дээд онооноос хэтэрсэн байна.");
              fb.db.collection("lessons").doc(this.lessonId).collection("scores").doc(score.topic.id).collection('sstudents').doc(student.id).set({
                modifiedAt: new Date()
              }, {merge:true});
              return ;
            }
            var procent=null;
            if(maxScore){
              procent=(score.data.earnedScore*100/maxScore)
            }
            fb.db.collection("/lessons").doc(this.lessonId).collection("scores").doc(score.topic.id).collection('sstudents').doc(student.id).set({
              modifiedAt: new Date(),
              earnedScore:score.data.earnedScore,
              procent: procent
            }, {merge:true});
          }
        },
        async finalScoreChanged(student){
          if(student && student.id && student.earnedScore){
            // var maxScore=100;
            // if(score.topic && score.topic.totalScore){
            //   maxScore=score.topic.totalScore;
            // }
            // if(score.data.earnedScore> maxScore){
            //   alert("Дээд онооноос хэтэрсэн байна.");
            //   fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("scores").doc(score.topic.id).collection('sstudents').doc(student.id).set({
            //     modifiedAt: new Date()
            //   }, {merge:true});
            //   return ;
            // }
            // var procent=null;
            // if(maxScore){
            //   procent=(score.data.earnedScore*100/maxScore)
            // }
            var doc=await fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(student.id).get();
            if(doc.exists){
              doc.ref.update({
                scoreModifiedAt: new Date(),
                earnedScore:student.earnedScore,
                // procent: procent
              });
            }
            else
              doc.ref.set({
                scoreModifiedAt: new Date(),
                earnedScore:student.earnedScore,
                addedDate: new Date(),
                studentRef: student && student.ref? student.ref:null,
                // addedUser:
                // procent: procent
              });
          }
        },
        addScore(){
          this.content={"name":null, "totalScore":null};
          $('#scoreModal').modal('toggle');
        },
        
        editScore(topic){
          this.content=Object.assign({}, topic); 
          $('#scoreModal').modal('toggle');
        },
        async saveScore(){
          if(this.content!=null && this.content.name!=null && this.content.name!='' && this.content.totalScore){

            if(this.content.id!=undefined && this.content.id!=null && this.content.id!='' && this.content.id!='new'){
              this.content.modifiedAt=new Date();
              fb.db.doc("lessons/"+this.lessonId).collection("scores").doc(this.content.id).update(this.content);
            }
            else{
              this.content.createdAt=new Date();
              this.content.code=new Date().getTime().toString();
              var contentRef= fb.db.doc("lessons/"+this.lessonId).collection("scores").doc();
              await contentRef.set(this.content);
    
          
              fb.db.doc("lessons/"+this.lessonId).update({
                'numberOfYvts':fb.firestore.FieldValue.increment(1)
              });

              let object=Object.assign({}, this.content);
              object.id = contentRef.id;
              object.groups=[];
              object.procent=0;
 
              this.topics.push(object);
              this.resetStudents();

            }
                
            this.content={
              'name':null
            }
      
            $('#scoreModal').modal('hide');
          }
          else{
            alert("Та талбаруудыг гүйцэд бөглөнө үү");
          }
        },
      _getAvg(topics){
        // console.log(topics);
        var sum=0;
        var count=0;
        for(const topicScore of topics){
          if(topicScore && topicScore.data && topicScore.data.earnedScore){
            sum+=topicScore.data.earnedScore;
            count++;
            
          }
        } 
        if(count!=0){
          return Math.round( sum/count);
        }
        return null;
      }
      ,
      _getSum(topics){
        var sum=0;
        var count=0;
        for(const topicScore of topics){
          if(topicScore && topicScore.data && topicScore.data.earnedScore){
            sum+=topicScore.data.earnedScore;
            count++;
            
          }
        } 
        if(count!=0){
          return Math.round(sum);
        }
        return null;
      },
      async _setFinal(type){
        if(type!=null && type!=undefined){
          var result = confirm("Энэ үйлдлийг хийсэнээр таны оруулсан эцсийн дүнгүүд устана.Та энэ үйлдлийг хийхдээ итгэлтэй байна уу?");
          if (result) {
            if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups && this.lesson.groups.length>0){
            for(const group of this.groups){
              if(group && group.students && group.students.length>0){
                
                for(const object of group.students){
                  if(object.topics && object.topics.length>0){
                    var avg=null;
                    if(type==0)
                      avg=this._getAvg(object.topics);
                    else if(type==1)
                      avg=this._getSum(object.topics);
                      
                    if(avg){
                      var doc=await fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(object.id).get();
                      if(doc.exists){
                        doc.ref.update({
                          scoreModifiedAt: new Date(),
                          earnedScore:avg,
                          // procent: procent
                        });
                      }
                      else
                        doc.ref.set({
                          scoreModifiedAt: new Date(),
                          earnedScore:avg,
                          addedDate: new Date(),
                          studentRef: student && student.ref? student.ref:null,
                          // addedUser:
                          // procent: procent
                        });
                    }
                  }
                } 
              }
            }
            
          }
            
          }
        }
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
      LessonInfo
    },
    props: {
      lessonId: { 
          required: true,
      },
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!=''){
          this._getQA();
          // this.readSchool();
        }
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>


<style>
  ::placeholder{
    color: white!important;
  }
</style>